import { gql } from '@apollo/client'

import { featuredEditFragment } from 'js/lib/fragments/featured'
import { iconEditFragment } from 'js/lib/fragments/icon'

import addEditFragment from './fragments/addEditFragment'
import { groupMenuFieldsFragment } from './GroupMenuFields.fragment'

export const EDIT_GROUP = gql`
    query EditGroup($guid: String!) {
        ${addEditFragment}
        entity(guid: $guid) {
            guid
            ... on Group {
                name
                description
                richDescription
                introduction
                welcomeMessage
                ${iconEditFragment}
                ${featuredEditFragment}
                isClosed
                isMembershipOnRequest
                isFeatured
                autoNotification
                fileNotification
                plugins
                canEdit
                url
                isChatEnabled
                tags
                tagCategories {
                    name
                    values
                }
                defaultTags
                defaultTagCategories {
                    name
                    values
                }
                isCollaboraEnabled
                isJoinButtonVisible
                isLeavingGroupDisabled
                isHidden
                isAutoMembershipEnabled
                autoMembershipFields {
                    field {
                        guid
                        name
                        fieldOptions
                    }
                    value
                }
                isIntroductionPublic
                showMemberProfileFieldGuids
                requiredProfileFieldGuids
                requiredProfileFieldsMessage
                vcardFieldGuids
                startPage {
                    guid
                }
                isMenuAlwaysVisible
                ...GroupMenuFields
            }
        }
        groupPages: entities(
            subtypes: ["landingpage", "page"]
            containerGuid: $guid
        ) {
            edges {
                ... on Page {
                    guid
                    title
                }
            }
        }
    }
    ${groupMenuFieldsFragment}
`
